import { render, staticRenderFns } from "./BillProfileDetail.vue?vue&type=template&id=83156300"
import script from "./BillProfileDetail.vue?vue&type=script&lang=js"
export * from "./BillProfileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports